import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Navbar, Nav, Spinner } from 'react-bootstrap'; // Spinner importieren!
import 'bootstrap/dist/css/bootstrap.min.css';
import './dashboard.css';
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [tokenProfitData, setTokenProfitData] = useState(null);
  const [allTimeHighData, setAllTimeHighData] = useState(null);
  const [tokenProfitError, setTokenProfitError] = useState('');
  const [allTimeHighError, setAllTimeHighError] = useState('');

  // NEU: Ladezustände für die API-Aufrufe
  const [loadingTokenProfit, setLoadingTokenProfit] = useState(false);
  const [loadingAllTimeHigh, setLoadingAllTimeHigh] = useState(false);

  const fetchTokenProfit = async () => {
    setLoadingTokenProfit(true); // Ladezustand auf true setzen
    setTokenProfitError(''); // Alte Fehlermeldung zurücksetzen
    setTokenProfitData(null); // Alte Daten zurücksetzen
    try {
      const response = await fetch(`${API_BASE_URL}/analyze/calculate-token-profit`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ coinName: 'bitcoin', amount: '5', start_date: '2024-05-09', stop_date: '2024-05-14', buy_diff: '1', sell_diff: '1' })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Fehler beim Berechnen des Token-Profits');
      }

      const data = await response.json();
      setTokenProfitData(data);
    } catch (error) {
      console.error('Fehler beim API-Call (Token Profit):', error);
      setTokenProfitError(error.message || 'Fehler beim Abrufen des Token-Profits');
    } finally {
      setLoadingTokenProfit(false); // Ladezustand auf false setzen, egal ob Erfolg oder Fehler
    }
  };

  const fetchAllTimeHigh = async () => {
    setLoadingAllTimeHigh(true); // Ladezustand auf true setzen
    setAllTimeHighError(''); // Alte Fehlermeldung zurücksetzen
    setAllTimeHighData(null); // Alte Daten zurücksetzen
    try {
      const response = await fetch(`https://api.t-soft.online/dotnet-api/api/coin/all-time-high`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ coinName: 'bitcoin' })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Fehler beim Abrufen des All-Time High');
      }

      const data = await response.json();
      setAllTimeHighData(data);
    } catch (error) {
      console.error('Fehler beim API-Call (All-Time High):', error);
      setAllTimeHighError(error.message || 'Fehler beim Abrufen des All-Time High');
    } finally {
      setLoadingAllTimeHigh(false); // Ladezustand auf false setzen
    }
  };

  return (
    <div className="app-dark">

      <Navbar bg="dark" variant="dark" expand="lg" className="mb-4 frosted-glass">
        <Container>
          <Navbar.Brand href="#home">Dashboard</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>Home</Nav.Link>
              <Nav.Link href="#features">Features</Nav.Link>
              <Nav.Link onClick={() => navigate("/Interact/main-page")} style={{ cursor: 'pointer' }}>Pricing</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="py-5">
        <Row className="gy-4">
          <Col md={6}>
            <Card className="frosted-glass" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
              <Card.Body>
                <Card.Title>Login</Card.Title>
                <Card.Text>
                  Hier steht ein wichtiger Wert oder eine Information.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="frosted-glass" onClick={() => navigate("/payment")} style={{ cursor: 'pointer' }}>
              <Card.Body>
                <Card.Title>Payment</Card.Title>
                <Card.Text>
                  Eine weitere wichtige Metrik oder Information.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="frosted-glass" onClick={() => navigate("/analyze")} style={{ cursor: 'pointer' }}>
              <Card.Body>
                <Card.Title>Analyze A</Card.Title>
                <Card.Text>
                  Kurze Zusammenfassung von Daten.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card
              className="frosted-glass"
              onClick={fetchTokenProfit}
              style={{ cursor: 'pointer' }}
            >
              <Card.Body>
                <Card.Title>Token profit</Card.Title>
                <Card.Text>
                  {/* Bedingtes Rendering für den Spinner */}
                  {loadingTokenProfit ? (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading Token Profit...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <>
                      Weitere Daten im Überblick.
                      {tokenProfitData && (
                          <p className="mt-2 text-success">Geladen: {JSON.stringify(tokenProfitData.someValue || 'Daten vorhanden')}</p>
                      )}
                    </>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="frosted-glass"
              onClick={fetchAllTimeHigh}
              style={{ cursor: 'pointer' }}
            >
              <Card.Body>
                <Card.Title>All time high</Card.Title>
                <Card.Text>
                  {/* Bedingtes Rendering für den Spinner */}
                  {loadingAllTimeHigh ? (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading All-Time High...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <>
                      Weitere Daten im Überblick.
                      {allTimeHighData && (
                          <p className="mt-2 text-success">Geladen: {allTimeHighData.allTimeHigh}</p>
                      )}
                    </>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Permanenter Anzeige-Bereich (unverändert, da die Spinner in den Karten sind) */}
      <div className="api-response-area frosted-glass mt-4 p-3">
        <h3>API Antworten</h3>
        {tokenProfitData && (
          <div>
            <h4>Token Profit</h4>
            <pre>{JSON.stringify(tokenProfitData, null, 2)}</pre>
          </div>
        )}
        {tokenProfitError && (
          <div className="alert alert-danger">
            <strong>Fehler (Token Profit):</strong> {tokenProfitError}
          </div>
        )}

        {allTimeHighData && (
          <div className="mt-3">
            <h4>All-Time High</h4>
            <pre>{JSON.stringify(allTimeHighData, null, 2)}</pre>
          </div>
        )}
        {allTimeHighError && (
          <div className="alert alert-danger mt-3">
            <strong>Fehler (All-Time High):</strong> {allTimeHighError}
          </div>
        )}

        {!tokenProfitData && !tokenProfitError && !allTimeHighData && !allTimeHighError && (
          <p>Klicke auf die Karten, um API-Daten abzurufen und hier anzuzeigen.</p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
